import classNames from "classnames";
import React from "react";

type HeatMapLabelProps = {
  label: string;
  rootClassName?: string;
};

export const HeatMapLabel = ({ label, rootClassName }: HeatMapLabelProps): JSX.Element => (
  <div className={classNames(rootClassName)}>{label}</div>
);
